var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.baseClass, _vm.modifierClasses]},[(_vm.$slots.content)?_c('div',[_vm._t("content")],2):_vm._e(),(_vm.$slots.actions)?_c('div',[_vm._t("actions")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }